import { useMemo, useState } from "react";
import { categories, topics } from "@/mocks/nanaData";

export default function CategoryBrowser() {
  const [active, setActive] = useState("全部热议");
  const [keyword, setKeyword] = useState("");

  const filtered = useMemo(() => {
    const kw = keyword.trim();
    return topics.filter((t) => {
      const matchCat = active === "全部热议" || t.category === active;
      const matchKw =
        !kw ||
        t.title.toLowerCase().includes(kw.toLowerCase()) ||
        t.summary.toLowerCase().includes(kw.toLowerCase()) ||
        t.tags.some((tag) => tag.toLowerCase().includes(kw.toLowerCase()));
      return matchCat && matchKw;
    });
  }, [active, keyword]);

  return (
    <section id="browse" className="bg-secondary-50/70 px-4 py-14 md:px-6 md:py-16" aria-label="围观广场">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-secondary-600">围观广场</span>
            <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl text-foreground-950">按分类逛一逛</h2>
            <p className="mt-2 text-sm text-foreground-500">切换分类或输入关键词，快速定位你感兴趣的话题。</p>
          </div>
          <div className="flex w-full items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-2 lg:w-80">
            <i className="ri-search-line text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索话题、标签关键词…"
              aria-label="搜索话题"
              className="w-full bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none"
            />
            {keyword && (
              <button onClick={() => setKeyword("")} aria-label="清除搜索" className="cursor-pointer text-foreground-400 hover:text-primary-500">
                <i className="ri-close-circle-fill"></i>
              </button>
            )}
          </div>
        </div>

        <div className="no-scrollbar mt-6 flex gap-2 overflow-x-auto">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => setActive(cat.name)}
              className={`inline-flex shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === cat.name
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-background-100"
              }`}
            >
              <i className={cat.icon}></i>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-between">
          <p className="text-sm text-foreground-500">
            共 <span className="font-semibold text-primary-600">{filtered.length}</span> 个相关话题
          </p>
        </div>

        {filtered.length > 0 ? (
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {filtered.map((topic) => (
              <article
                key={topic.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-secondary-300"
              >
                <div className="relative h-36 overflow-hidden">
                  <img
                    src={topic.image}
                    alt={topic.title}
                    title={topic.title}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-secondary-700 px-2.5 py-1 text-[11px] text-background-50">
                    {topic.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <h3 className="text-sm font-semibold leading-snug text-foreground-900 group-hover:text-secondary-700">
                    {topic.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{topic.summary}</p>
                  <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {topic.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {topic.comments.toLocaleString()}
                    </span>
                    <span className="whitespace-nowrap">{topic.time}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-4 flex flex-col items-center justify-center rounded-2xl border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <i className="ri-file-search-line text-4xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-500">没有找到匹配的话题，换个关键词或分类试试吧。</p>
            <button
              onClick={() => {
                setKeyword("");
                setActive("全部热议");
              }}
              className="mt-4 cursor-pointer rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              查看全部话题
            </button>
          </div>
        )}
      </div>
    </section>
  );
}